import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const StickersIcon = ({ color = '#798588', size = 24, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M23.825 5.747 18.276.177A.598.598 0 0 0 17.85 0H5.4A5.406 5.406 0 0 0 0 5.4v13.2A5.406 5.406 0 0 0 5.4 24h13.2a5.406 5.406 0 0 0 5.4-5.4V6.17a.602.602 0 0 0-.175-.423zm-1.056.64a3.98 3.98 0 0 1-4.094-1.062 3.979 3.979 0 0 1-1.057-4.108l5.151 5.17zM18.6 22.8H5.4a4.205 4.205 0 0 1-4.2-4.2V5.4a4.205 4.205 0 0 1 4.2-4.2h10.96a5.183 5.183 0 0 0 1.467 4.973 5.384 5.384 0 0 0 3.776 1.634 4.592 4.592 0 0 0 1.197-.172V18.6a4.205 4.205 0 0 1-4.2 4.2zm-3.072-8.882a3.601 3.601 0 0 1-7.057 0 .6.6 0 0 1 1.176-.236 2.401 2.401 0 0 0 4.704 0 .6.6 0 0 1 1.176.236h.001zM8.4 11.408a.604.604 0 0 1-.6.589l-.007-.002A.596.596 0 0 1 7.2 11.4a1.8 1.8 0 0 1 3.6 0 .6.6 0 0 1-1.2.006.6.6 0 1 0-1.2.001zm8.4-.008a.6.6 0 0 1-1.2.006.6.6 0 1 0-1.2.001.604.604 0 0 1-.6.59l-.007-.002a.596.596 0 0 1-.593-.595 1.8 1.8 0 0 1 3.6 0z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
);

StickersIcon.propTypes = propTypes;

export default StickersIcon;
